<template>
  <w-icon-wrapper
    :height='23.86'
    :width='23.857'
    icon-name='work-unlink-icon'
    view-box='0 0 23.857 23.86'
  >
    <g
      id='_55_Verlinkung_aufgehoben_Icon'
      data-name='55 Verlinkung aufgehoben_Icon'
      transform='translate(-0.11 0.01)'
    >
      <path
        id='Pfad_55751'
        d='M6.59,21.09a2.642,2.642,0,0,1-1.86.76,2.623,2.623,0,0,1-1.85-4.48l5.14-5.13L6.6,10.82,1.46,15.96A4.624,4.624,0,0,0,8,22.5l5.14-5.14-1.41-1.41Z'
        data-name='Pfad 55751'
        fill='currentColor'
      />
      <path
        id='Pfad_55752'
        d='M22.61,1.35a4.6,4.6,0,0,0-6.53,0L10.81,6.61l1.42,1.42,5.26-5.27a2.625,2.625,0,0,1,4.48,1.86,2.57,2.57,0,0,1-.77,1.85l-5.26,5.27,1.41,1.41,5.26-5.26A4.617,4.617,0,0,0,22.61,1.35Z'
        data-name='Pfad 55752'
        fill='currentColor'
      />
      <path
        id='Pfad_55753'
        d='M20.84,19.45a1.826,1.826,0,0,0-.13-.16l-4.75-4.75-1.41-1.41L10.84,9.42,9.42,8,4.71,3.29a1.826,1.826,0,0,0-.16-.13V3.15a1.03,1.03,0,0,0-1.26.14,1,1,0,0,0-.05,1.36.265.265,0,0,0,.05.06L8,9.42l1.42,1.42,3.71,3.71,1.41,1.41,4.75,4.75c.02.01.03.03.05.04A.973.973,0,0,0,20,21a1.006,1.006,0,0,0,.85-1.55Z'
        data-name='Pfad 55753'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconUnlink' };
</script>
